import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CtaButtonSignalService } from '@app/finxone-web-frontend/app/lib/services/cta-button-signal-service/cta-button-signal.service';
import { WorkflowFormsService } from '@app/finxone-web-frontend/app/lib/services/workflow-forms/workflow-forms.service';
import { FormActionState } from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { FormID } from '@finxone-platform/form-action';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

export const savingsAccountCtaValidationMap: Map<
  ButtonActionType,
  (
    store: Store,
    ctaButtonSignalService: CtaButtonSignalService,
    attri?: UiZoneWidgetAttributeConfig,
    _?: ConfigService,
    workflowFormsService?: WorkflowFormsService,
  ) => Observable<boolean>
> = new Map<ButtonActionType, any>([
  [
    ButtonActionType.CLOSE_SAVINGS_ACCOUNT,
    (
      store: Store,
      ctaButtonSignalService: CtaButtonSignalService,
      attri: UiZoneWidgetAttributeConfig,
      __?: ConfigService,
      workflowFormsService?: WorkflowFormsService,
    ) => {
      const forms = store.select(FormActionState.getFormActionStateWithId(FormID.CLOSING_ACCOUNT_FORM));
      const key: string = attri?.['buttonActionType'] as string;

      ctaButtonSignalService.setSignal({
        [key]: false,
      });

      return forms?.subscribe({
        next: (res) => {
          const formValue = res?.formData;

          const closingAccountForms = Array.from(workflowFormsService?.forms().keys() ?? []).filter((k) =>
            k.startsWith(FormID.CLOSING_ACCOUNT_FORM),
          );
          const isFormValid =
            closingAccountForms.length > 0
              ? closingAccountForms.every((k) => workflowFormsService?.isFormValid(k) ?? false)
              : false;

          ctaButtonSignalService.setSignal({
            [key]: !!(formValue?.['accountId'] && isFormValid),
          });
        },
      });
    },
  ],
]);
